import { DownloadBalanceListController } from './downloadBalanceList.controller';
import template from './downloadBalanceList.html';

export const downloadBalanceListComponent = {
  name: 'downloadBalanceListComponent',
  restrict: 'E',
  template,
  controller: DownloadBalanceListController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<'
  }
};
